import { Convert } from '@itus/ui.common'
import { RiskAnalysisAssetModel } from './risk-analysis-asset-model'

export class RiskAnalysisModel {
  constructor(data) {
    data = data || {}
    this.analysis = data.id ? Convert.toString(data.id, null) : Convert.toString(data.analysis, null)
    this.analysisName = Convert.toString(data.analysisName, null)
    this.description = Convert.toString(data.description, null)
    this.startDate = Convert.toString(data.startDate, null)
    this.endDate = Convert.toString(data.endDate, null)
    this.missionTime = Convert.toString(data.missionTime, null)
    this.probabilityThreshold = Convert.toInteger(data.probabilityThreshold, 50)
    this.assets = data.assets ? data.assets.map(x => new RiskAnalysisAssetModel(x)) : []
  }
}
export default { RiskAnalysisModel }
